import { MMKV } from 'react-native-mmkv';

import { noCircularLogger } from 'utils/logger/no-circular-logger';

/** MMKV storage instance, used for fast/sync storage. Please use the public API below for most cases. */
export const _mmkvStorage = new MMKV();

/** MMKV backed fast SYNC storage */
export const syncStorage = {
  getObject: (key: SyncStorageKey) => {
    let value: any;
    try {
      value = _mmkvStorage.getString(key);
      return value ? JSON.parse(value) : null;
    } catch (error) {
      noCircularLogger('error', {
        message: 'syncStorage failed to parse JSON',
        context: { key, value },
        error,
      });
      return null;
    }
  },
  setObject: (key: SyncStorageKey, value: any) => {
    return _mmkvStorage.set(key, JSON.stringify(value));
  },
  getString: (key: SyncStorageKey) => {
    return _mmkvStorage.getString(key);
  },
  setString: (key: SyncStorageKey, value: string) => {
    return _mmkvStorage.set(key, value);
  },
  delete: (key: SyncStorageKey) => {
    return _mmkvStorage.delete(key);
  },
  clearAll: () => {
    return _mmkvStorage.clearAll();
  },
};

/** keys for mmkv storage, TODO migrate over LocalStorage keys */
export enum SyncStorageKey {
  DEVICE_ID = 'RBI::DEVICE_ID',
  LAUNCH_DARKLY_USER_ATTRIBUTES = 'RBI::LAUNCH_DARKLY_USER_ATTRIBUTES',
  LANGUAGE = 'RBI::LANGUAGE',
  INTERNAL_BUILD_ONLY_ENV_PICKER_CONFIG = 'RBI::INTERNAL_BUILD_ONLY_ENV_PICKER_CONFIG',
}
